:host {
  @include reset-host;
  @include reset-media;
}

:host .ethias-baseline {
  margin-bottom: rem(8);

  @include mq('max', 'md') {
    max-width: rem(300);
  }

  &.no-margin {
    margin-bottom: 0;
  }
}
